<template>
	<div class="splitter-context-helper">

	  <div class="splitter-context-control">
      <div class="splitter-context-label">{{ label }}</div>
      <div class="splitter-context-measurement">{{ value }}</div>
    </div>

	</div>
</template>

<style>
.splitter-context-helper {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.splitter-context-control {
  flex: 0 0;
  padding: 10px 20px 10px 20px;
  background: #f7f7f7;
  border-bottom: 1px solid #e6e6e6;
}
.splitter-context-label {
  font-weight: 600;
  font-size: 0.9em;
  color: #666666;
}
.splitter-context-measurement {
  font-weight: 600;
}
</style>

<script>
export default {
  name: 'spliter-context-helper',

  props: {
    label: {
      type: String,
    },
    value: {
      type: String,
    },
  },

  data() {
    return {};
  },

  computed: {},

  methods: {},

  watch: {},

  mounted() {},
}
</script>